import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { CategoryExplainer } from './components/CategoryExplainer';
import { ToolProfiles } from './components/ToolProfiles';
import { ComparisonMatrix } from './components/ComparisonMatrix';
import { AIModules } from './components/AIModules';
import { ChooseGuide } from './components/ChooseGuide';
import { NewsSection } from './components/NewsSection';
import { FAQ } from './components/FAQ';
import { Methodology } from './components/Methodology';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-slate-950 text-slate-300 font-sans selection:bg-indigo-500/30" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <CategoryExplainer data-id="element-4" />
        <ToolProfiles data-id="element-5" />
        <AIModules data-id="element-6" />
        <ComparisonMatrix data-id="element-7" />
        <ChooseGuide data-id="element-8" />
        <NewsSection data-id="element-9" />
        <FAQ data-id="element-10" />
        <Methodology data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}